export default "__VITE_ASSET__98e7ac66__"